import { render, staticRenderFns } from "./AtmoInfoCo2.vue?vue&type=template&id=79ba4238&scoped=true&"
import script from "./AtmoInfoCo2.vue?vue&type=script&lang=ts&"
export * from "./AtmoInfoCo2.vue?vue&type=script&lang=ts&"
import style0 from "./AtmoInfoCo2.vue?vue&type=style&index=0&id=79ba4238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ba4238",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79ba4238')) {
      api.createRecord('79ba4238', component.options)
    } else {
      api.reload('79ba4238', component.options)
    }
    module.hot.accept("./AtmoInfoCo2.vue?vue&type=template&id=79ba4238&scoped=true&", function () {
      api.rerender('79ba4238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/integrations/templates/AtmoInfoCo2.vue"
export default component.exports